import { FormattedMessage } from "react-intl";
import { useEffect } from "react";

import "./Terms.css";

const Terms = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<div className="privacy-policy-wrapper">
			<div className="privacy-policy">
				<h3 className="terms__title">
					CloudOrder.US
					<br />
					<FormattedMessage id="termsAndConditions" />
				</h3>
				<p className="privacy-policy__last-updated">
					<span className="privacy-policy__bold-text">
						<FormattedMessage id="lastUpdated" />
					</span>{" "}
					<FormattedMessage id="termsLastUpdateDate" />
				</p>
				<h4 className="privacy-policy__section-title">
					<FormattedMessage id="1AcceptanceOfTerms" />
				</h4>
				<p>
					<FormattedMessage id="byAccessingBrowsingOrUsingCloudOrderTheSite" />
				</p>
				<h4 className="privacy-policy__section-title">
					<FormattedMessage id="2LicenseToUseTheSite" />
				</h4>
				<p>
					<FormattedMessage id="cloudOrderGrantsYouALimitedRevocableNonTransferable" />
				</p>
				<h4 className="privacy-policy__section-title">
					<FormattedMessage id="3UserConductAndResponsibilities" />
				</h4>
				<p>
					<FormattedMessage id="youMayNotUploadDistributeOrPublishContentThatInfringesOnCopyrights" />
				</p>
				<h4 className="privacy-policy__section-title">
					<FormattedMessage id="submissionsReviewsAndComments" />
				</h4>
				<p>
					<FormattedMessage id="anySubmissionsEgReviewsCommentsIdeasYouPostToTheSiteAreNonConfidential" />
				</p>
				<h4 className="privacy-policy__section-title">
					<FormattedMessage id="intellectualProperty" />
				</h4>
				<p>
					<FormattedMessage id="allContentOnTheSiteAndItsCompilationAreOwnedByCloudOrderOrItsSuppliers" />
				</p>
				<h4 className="privacy-policy__section-title">
					6.{" "}
					<FormattedMessage id="intellectualPropertyInfringementPolicy" />
				</h4>
				<p>
					<FormattedMessage id="cloudOrderCompliesWithStateFederalAndInternationalLawsRegardingIntellectualProperty" />
				</p>
				<h4 className="privacy-policy__section-title">
					<FormattedMessage id="7OrderAcceptanceAndPricing" />
				</h4>
				<p>
					<FormattedMessage id="cloudOrderMayRefuseOrCancelOrdersAtItsDiscretion" />
				</p>
				<h4 className="privacy-policy__section-title">
					<FormattedMessage id="8ThirdPartyLinks" />
				</h4>
				<p>
					<FormattedMessage id="thiSiteMayContainLinksToThirdPartySites" />
				</p>
				<h4 className="privacy-policy__section-title">
					<FormattedMessage id="9Termination" />
				</h4>
				<p>
					<FormattedMessage id="cloudOrderMayTerminateThisAgreementOrRevokeYourAccessWithoutNoticeForAnyBreach" />
				</p>
				<h4 className="privacy-policy__section-title">
					<FormattedMessage id="10Remedies" />
				</h4>
				<p>
					<FormattedMessage id="cloudOrdersLegalRemediesForBreachesAreInadequate" />
				</p>
				<h4 className="privacy-policy__section-title">
					<FormattedMessage id="11GoverningLaw" />
				</h4>
				<p>
					<FormattedMessage id="thisAgreementIsGovernedByUSLaws" />
				</p>
			</div>
		</div>
	);
};
export default Terms;
